import _extends from "@babel/runtime/helpers/extends";
import * as React from 'react';
import * as styles from './styles.css';
import { mergeStyles } from '@cian/utils';
import { EInputType } from '../../types';
var MAX_LENGTH_INPUT_TEXT = 255;
var INPUT_PLACEHOLDER_TEXT = 'Город, адрес, метро, район, ж/д, шоссе или ЖК';
var INPUT_LABEL_TEXT = 'Город, район, метро, адрес';
export var SuggestionInput = function SuggestionInput(props) {
  var value = props.value,
      inputType = props.inputType,
      inputStyle = props.inputStyle,
      onKeyDown = props.onKeyDown,
      _onChange = props.onChange,
      onFocus = props.onFocus,
      disabled = props.disabled,
      placeholder = props.placeholder,
      forwardRef = props.forwardRef,
      renderInput = props.renderInput;
  var isMainpage = inputType === EInputType.mainpage;
  var isCustomInput = inputType === EInputType.custom;

  if (isCustomInput && renderInput) {
    var inputProps = {
      value: value,
      disabled: disabled,
      placeholder: placeholder,
      onChange: _onChange,
      onKeyDown: onKeyDown,
      onFocus: onFocus,
      forwardRef: forwardRef
    };
    return renderInput(inputProps);
  }

  return /*#__PURE__*/React.createElement(React.Fragment, null, isMainpage && /*#__PURE__*/React.createElement("label", {
    htmlFor: "geo-suggest-input",
    className: styles['suggestion-input-label']
  }, placeholder || INPUT_LABEL_TEXT), /*#__PURE__*/React.createElement("input", _extends({}, mergeStyles(styles['suggestion-input'], inputType === EInputType.mobile && styles['mobile'], inputType === EInputType.tablet && styles['tablet'], inputType === EInputType.map && styles['map'], inputType === EInputType.search && styles['search'], isMainpage && styles['mainpage'], inputStyle), {
    id: "geo-suggest-input",
    value: value,
    ref: forwardRef,
    maxLength: MAX_LENGTH_INPUT_TEXT,
    autoComplete: "off",
    onKeyDown: onKeyDown,
    onChange: function onChange(event) {
      _onChange(event.currentTarget.value);
    },
    onFocus: onFocus,
    disabled: disabled,
    placeholder: isMainpage ? undefined : placeholder || INPUT_PLACEHOLDER_TEXT
  })));
};